<xm-modal-close class="close-btn" xmEscKey (escKeyPressed)="close('close')" (onClose)="close('close')"></xm-modal-close>
<section>
    <xm-media-image [imageOptions]="createImageOption(data.icon)" size="width"></xm-media-image>
    <h2 mat-dialog-title class="header">{{ data.header }}</h2>
    <p class="subheader">{{ data.subHeader }}</p>
    <div class="desktop-view">
        <table>
            <tr>
                <th></th>
                <th class="left-header">{{data.tableContent.leftHeader}}</th>
                <th>{{data.tableContent.rightHeader}}</th>
            </tr>
            <tr *ngFor="let row of data.tableContent.rows; let isLast = last">
                <td>{{ row.label }}</td>
                <td><p>{{ row.leftPlan }}</p>
                <p>{{ row.leftPlanPrice}}</p></td>
                <td><p>{{ row.rightPlan }}</p>
                <p>{{ row.rightPlanPrice}}</p></td>
            </tr>
        </table>
    </div>
    <div class="mobile-view">
        <div class="headers">
            <p class="left-header">{{data.tableContent.leftHeader}}</p>
            <p class="right-header">{{data.tableContent.rightHeader}}</p>
        </div>
        <div class="table-container">
            <div class="row" *ngFor="let row of data.tableContent.rows;">
                <div class="label">{{row.label}}</div>
                <div class="row-data">
                    <div class="item">
                        <p>{{row.leftPlan}}</p>
                        <p>{{row.leftPlanPrice}}</p>
                    </div>
                    <div class="item">
                        <p>{{row.rightPlan}}</p>
                        <p>{{row.rightPlanPrice}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <button class="xm-btn-primary-light primary-btn" (click)="close('primary')">{{ data.primaryBtn }}</button>
</section>
